import { collection, doc, writeBatch } from 'firebase/firestore';
import { db } from '../firebase';

function fieldsForCreate(event, userId) {
  const fields = { userId };
  for (const [key, value] of Object.entries(event)) {
    if (value === undefined || value === '') continue;
    fields[key] = value;
  }
  return fields;
}

/** Write the starter-plan events in one batch and return them with ids. */
export async function saveStarterEvents(userId, events) {
  const batch = writeBatch(db);
  const saved = [];
  for (const event of events) {
    const ref = doc(collection(db, 'events'));
    const fields = fieldsForCreate(event, userId);
    batch.set(ref, fields);
    saved.push({ ...fields, id: ref.id });
  }
  await batch.commit();
  return saved;
}
